import * as actions from "../../actions/charges";

const initialState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false },
	errors: {},
};

const reducer = function (state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_CHARGES: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors,
			};
		}
		case actions.GET_CHARGES_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false },
			};
		}
		case actions.GET_CHARGES_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload,
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload,
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState,
			};
		default: {
			return state;
		}
	}
};

export default reducer;
